angular.module('app').factory('androidAppService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer) {
            Configurer.setBaseUrl(settings.apiURL);
        });

        var android = restAngular.all("/deviceProducts/");

        return {
            saveData: function (requestData) {
                return android.
                one("publishAndroidProduct").
                post("", requestData)
            },
            loadData: function () {
                return android.
                one("getAndroidProducts").
                get()
            },
            loadCasinoDomain: function(skinId) {
                return android.
                one("getAndroidCasinoDomain").
                customGET(param({skin_id: skinId}));
            },
            loadIosCasinoDomain: function(skinId) {
                return android.
                one("getIosCasinoDomain").
                customGET(param({skin_id: skinId}));
            },
            saveCasinoDomain: (function (requestData) {
                return android.
                one("setAndroidCasinoDomain").
                post("", requestData);
            }),
            saveIosCasinoDomain: (function (requestData) {
                return android.
                one("setIosCasinoDomain").
                post("", requestData);
            }),
            loadPromo: function (requestData) {
                return android.
                one("getAndroidPromoApp").
                customGET(param(requestData));
            },
            loadPromoOptions: function () {
                return android.
                one("getAndroidPromoAppOptions").
                get()
            },
            savePromo: function (requestData) {
                return android.
                one("saveAndroidPromoApp").
                post("", requestData);
            }


        }
    }
]);
